module.exports = __webpack_public_path__ + "static/img/produto_g.379d8c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/antares-sgas/produto_g.png
// module id = U1m9
// module chunks = 0